import { createContext, useContext } from 'react';
import type { ProjectAction } from '@trinity/chat/enums';
import { createNamedContext } from '@trinity/chat-components';
import type { SurveyAggregate, SurveyFiltering, SurveyQuestion, SurveyVersion } from '@trinity/chat/types/survey';

export type SurveyQuestionFilterContextValue = {
  filter: SurveyFiltering.FilterEntries;
  resetFilter: () => void;
  setFilter: (filter: SurveyFiltering.FilterEntries) => void;
  //questionData: SurveyQuestion[];
};

export type SurveyResponsesFilterDataContextValue = {
  surveyData: SurveyVersion[];
  allResponses: Record<number, SurveyAggregate.QuestionMap>;
  allQuestions: Record<number, SurveyQuestion[]>;
  isLoading: boolean;
};

export type ProjectActionsContextValue = Record<ProjectAction, () => void> & IProjectId;

export type ProjectActionsValidityContextValue = Record<ProjectAction, boolean>;

export const ProjectActionsContext = createNamedContext<ProjectActionsContextValue>(undefined, 'Project.Actions.Context');
export const ProjectActionsValidityContext = createContext<ProjectActionsValidityContextValue>(undefined);

export const ProjectResponseFilterContext = createNamedContext<SurveyQuestionFilterContextValue>(undefined, 'ProjectResponseFilterContext');
export const SurveyResponsesFilterDataContext = createNamedContext<SurveyResponsesFilterDataContextValue>(undefined, 'SurveyResponsesFilterDataContext');

export const useProjectSurveyResponsesFilterContext = () => useContext(ProjectResponseFilterContext);
export const useSurveyFilterDataContext = () => useContext(SurveyResponsesFilterDataContext);